const Table = {
  baseStyle: {
    thead: {
      bgColor: '#fff',
      boxShadow: 'rgba(0, 0, 0, 0.025) 0px 4px 4px',
      borderBottom: '1pt solid',
      borderBottomColor: 'gray.150',
      h: '64px',
    },
    th: {
      borderBottom: 'none',
    },
    td: {
      borderBottom: 'none',
    },
  },
  sizes: {
    md: {
      th: {
        py: '18px',
        px: '8px',
      },
      td: {
        py: '18px',
        px: '8px',
      },
    },
  },
  variants: {
    simple: {
      th: {
        color: '#272A2A',
        fontWeight: 600,
      },
    },
  },
}

export default Table
